export enum MedicalOrderChannel {
  CREATE = 'medicalOrder::create',
  EDIT = 'medicalOrder::patch',
  DELETE = 'medicalOrder::delete',
}
